export const sxStyled = theme => ({
  headerContainer: {
    height: { xs: '90px', sm: '110px' },
    px: { xs: '20px', sm: '36px' },
    bgcolor: theme.headerColor,
  },

  container: {
    bgcolor: '#F2F2F2',
    p: { xs: '40px 0', sm: '50px' },
    height: 'auto',
    minHeight: '100vh',
  },

  logo: {
    width: 'auto',
    height: '70px',
    mr: { xs: 0, sm: '20px' },
  },

  btn: {
    bgcolor: '#b0e098',
    width: '200px',
    color: '#000',
    fontWeight: 'bold',
    boxShadow: '0 0.30769em 0.56923em 0 rgb(0 0 0 / 39%)',
    '&:hover': {
      bgcolor: '#93e56b',
    },
    '&:disabled': {
      bgcolor: '#b0e09852',
    },
  },
});
